module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2022_17.21a69774.jpg";